import {
    Crown,
    Sunrise,
    PartyPopper,
    Flame,
    Cross,
    MoonStar,
    Users,
    Shirt,
    Gem,
} from "lucide-react";

export const PHONE_DISPLAY = "078068 63141";
export const PHONE_TEL = "tel:+917806863141";
export const WHATSAPP_URL = `https://wa.me/917806863141?text=${encodeURIComponent(
    "Hi Monisha! I found you on Google. I'd like to book a bridal makeup session — please share availability and package details.",
)}`;
export const ADDRESS =
    "No 293, MP Complex, Chennai - Tiruvallur High Rd, Thiruninravur, Thiruvenkada Nagar, Tamil Nadu 602024";
export const MAPS_EMBED = `https://www.google.com/maps?q=${encodeURIComponent(
    ADDRESS,
)}&output=embed`;

export const HERO_IMAGE = "/portfolio/bride-4.jpg";

export const BENEFITS = [
    "HD & Long-lasting Makeup",
    "Customized Bridal Looks",
    "All Religion Wedding Expertise",
    "Premium International Products",
    "Home Service Available",
    "On-time Service",
];

export const SERVICES = [
    { icon: Crown, name: "Bridal Makeup", desc: "Complete HD bridal transformation for your big day" },
    { icon: Sunrise, name: "Muhurtham Makeup", desc: "Traditional early-morning muhurtham looks, always on time" },
    { icon: PartyPopper, name: "Party Makeup", desc: "Glam looks for receptions, engagements & parties" },
    { icon: Flame, name: "Hindu Wedding Makeup", desc: "Authentic traditional styling for every ritual" },
    { icon: Cross, name: "Christian Wedding Makeup", desc: "Soft, elegant looks for white-gown ceremonies" },
    { icon: MoonStar, name: "Muslim Wedding Makeup", desc: "Graceful Nikkah & Walima bridal looks" },
    { icon: Users, name: "Bridesmaid Makeup", desc: "Coordinated glam for your entire squad" },
    { icon: Shirt, name: "Saree Pre-Pleating", desc: "Perfect pleats, pressed and ready to wear" },
    { icon: Gem, name: "Rental Bridal Jewellery", desc: "Premium imitation bridal sets available on rent" },
];

export const PORTFOLIO = [
    {
        url: "/portfolio/bride-4.jpg",
        alt: "Muhurtham makeup Chennai – traditional Hindu bride with jasmine garland by Monisha Makeover Artistry",
    },
    {
        url: "/portfolio/bride-2.jpg",
        alt: "Bridal makeup artist in Chennai – red lehenga bridal look with HD makeup",
    },
    {
        url: "/portfolio/bride-9.jpg",
        alt: "Bridal makeup artist in Chennai – traditional bride in peach silk saree with temple jewellery",
    },
    {
        url: "/portfolio/bride-3.jpg",
        alt: "Wedding makeup Chennai – reception look in pink lehenga by Monisha Makeover Artistry",
    },
    {
        url: "/portfolio/bride-10.jpg",
        alt: "Muhurtham makeup Chennai – bride in red silk saree with gold jewellery by Monisha Makeover Artistry",
    },
    {
        url: "/portfolio/bride-5.jpg",
        alt: "Christian wedding makeup Chennai – white gown bridal look by Monisha Makeover Artistry",
    },
    {
        url: "/portfolio/bride-6.jpg",
        alt: "Engagement makeup Chennai – pink silk saree look with rose garland",
    },
    {
        url: "/portfolio/bride-8.jpg",
        alt: "Reception makeup Chennai – blue lehenga look with henna by Monisha Makeover Artistry",
    },
    {
        url: "/portfolio/bride-1.jpg",
        alt: "Makeup artist in Thiruninravur – blue gown reception bridal look",
    },
    {
        url: "/portfolio/bride-7.jpg",
        alt: "Party makeup Chennai – pink lehenga reception look by makeup artist in Thiruninravur",
    },
];

export const TESTIMONIALS = [
    {
        name: "Priya Srinivasan",
        location: "Avadi, Chennai",
        quote: "Monisha did my muhurtham makeup at 4 AM and the look stayed flawless till evening. She understood exactly what I wanted — traditional yet elegant.",
    },
    {
        name: "Farhana Khan",
        location: "Thiruninravur",
        quote: "Booked her for my Nikkah and Walima. So professional, on time, and the HD finish looked stunning in every photo. Highly recommended!",
    },
    {
        name: "Rachel Joseph",
        location: "Tiruvallur",
        quote: "My church wedding look was soft, graceful and lasted the whole day. The home service made everything stress-free for me and my family.",
    },
    {
        name: "Divya Ramesh",
        location: "Chennai",
        quote: "From saree pre-pleating to jewellery rental, she handled everything. My bridesmaids loved their looks too. Worth every rupee!",
    },
];
